import { render, staticRenderFns } from "./OrdertongpeiDetails.vue?vue&type=template&id=698b6140&scoped=true"
import script from "./OrdertongpeiDetails.vue?vue&type=script&lang=js"
export * from "./OrdertongpeiDetails.vue?vue&type=script&lang=js"
import style0 from "./OrdertongpeiDetails.vue?vue&type=style&index=0&id=698b6140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698b6140",
  null
  
)

export default component.exports